const sx = {
  appBar: {
    backgroundColor: '#122549',
    boxShadow: 'none',
    position: 'static',
  },
  toolbar: {
    minHeight: { xs: 64, md: 80 },
  },
  logoContainer: {
    width: { xs: 140, md: 180 },
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    textDecoration: 'none',
  },
}

export default sx
